
import {Module, MutationTree, GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {OriginDeterminationFiltersState, OriginDeterminationSearchFilter} from "./types";

export const state: OriginDeterminationFiltersState = {
    date_filter: {
        date: ''
    },
    status_filter: {
        determination_status: ''
    },
    search_filter: {
        search_option: '',
        search_content: ''
    },
    originating_filter: {
        originating_status: ''
    },
    trade_section_filter: {
        trade_section_status: ''
    },
    agreement_group_filter: {
        agreemen_group_status: ''
    }
};
  
const mutations: MutationTree<OriginDeterminationFiltersState> = {
    SET_ORIGIN_DETERMINATION_DATE_FILTER(state, date: string) {
        state.date_filter.date = date;
    },
    SET_ORIGIN_DETERMINATION_STATUS_FILTER(state, status: string) {
        state.status_filter.determination_status = status;
    },
    SET_ORIGIN_DETERMINATION_SEARCH_FILTER(state, searchOptions: OriginDeterminationSearchFilter) {
        state.search_filter = searchOptions;
    },
    SET_ORIGIN_DETERMINATION_ORIGINATING_FILTER(state, status: string) {
        state.originating_filter.originating_status = status;
    },
    SET_ORIGIN_DETERMINATION_TRADE_SECTION_FILTER(state, status: string) {
        state.trade_section_filter.trade_section_status = status;
    },
    SET_ORIGIN_DETERMINATION_AGREEMENT_GROUP_FILTER(state, status: string) {
        state.agreement_group_filter.agreemen_group_status = status;
    },
}

const getters: GetterTree<OriginDeterminationFiltersState, RootState> = {
    ORIGIN_DETERMINATION_DATE_FILTER(state): string | undefined {
      return state.date_filter.date;
    },
    ORIGIN_DETERMINATION_STATUS_FILTER(state) :string | undefined {
        return state.status_filter.determination_status;
    },
    ORIGIN_DETERMINATION_ORIGINATING_FILTER(state) :string | undefined {
        return state.originating_filter.originating_status;
    },
    ORIGIN_DETERMINATION_SEARCH_FILTER(state) {
        return state.search_filter;
    },
    ORIGIN_DETERMINATION_TRADE_SECTION_FILTER(state) {
        return state.trade_section_filter.trade_section_status;
    },
    ORIGIN_DETERMINATION_AGREEMENT_GROUP_FILTER(state) {
        return state.agreement_group_filter.agreemen_group_status;
    }
}
  
export const origin_determination_filter: Module<OriginDeterminationFiltersState, RootState> = {
    state,
    mutations,
    getters
}